import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import MuiLink from '@mui/material/Link'

import { CuppingSessionSample } from '../../types/cuppingSession'
import { getCuppingSampleCoffeeName } from '../../utils/cuppingUtils'

interface CuppingSampleLinkProps {
  sample: CuppingSessionSample
}

const CuppingSampleLink = (props: CuppingSampleLinkProps): JSX.Element => {
  const { t } = useTranslation()

  const sampleName = getCuppingSampleCoffeeName(props.sample, t('logview.batch'))
  return props.sample.log_data?.machine_slug ? (
    <MuiLink
      component={Link}
      target="_blank"
      rel="noopener noreferrer"
      to={`/machine/${props.sample.log_data?.machine_slug}/logs/${props.sample.log_data?.id}/`}
    >
      {sampleName}
    </MuiLink>
  ) : (
    <>{sampleName}</>
  )
}

export default CuppingSampleLink
